import { Button } from "@mui/material";
import React from "react";

const PlanoButton = ({
  css,
  mainfunction,
  children,
  extraCss,
  startIcon,
  dissable,
  className = "",
}) => {
  return (
    <Button
      className={className}
      disabled={dissable}
      startIcon={startIcon}
      sx={
        css
          ? css
          : {
              backgroundColor: "#f04e23 !important",
              color: "white",
              height: "inherit",
              textAlign: "left",
              ":hover": { backgroundColor: "#f04e23 !important" },
              ...extraCss,
            }
      }
      onClick={() => {
        mainfunction
          ? mainfunction()
          : console.log("Function Yet to be defined");
      }}
    >
      {children}
    </Button>
  );
};

export default PlanoButton;
